<template>
  <div class="sectionSubtitle">
    <span>{{ title }}</span>
    <span
      class="sectionFinePrint"
      style="white-space: nowrap"
    >{{ periodLabel }}</span>
  </div>
</template>

<script>

export default {
  name: 'StatsBlockTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    period: {
      type: Number,
      required: true,
    },
  },
  computed: {
    periodLabel: function () {
      switch (this.period) {
        case 30:
          return 'previous 30 days'

        case 90:
          return 'previous 90 days'

        case 365:
          return 'previous year'

        default:
          return ''
      }
    },
  },
}

</script>
